export default class MapUtil {
    static isAnyChildSelected(cluster) {
        let isChildSelected = false;
        cluster &&
            cluster.some &&
            cluster.some(point => {
                if (point.child.props.isSelected) {
                    isChildSelected = true;
                    return true;
                }
                return false;
            });
        return isChildSelected;
    }

    static isAnyChildHovered(cluster) {
        var isChildHovered = false;
        cluster &&
            cluster.some &&
            cluster.some(point => {
                const { isMarkerSelfHovered, isHovered } = point.child.props;
                if (isMarkerSelfHovered || isHovered) {
                    isChildHovered = true;
                    return true;
                }
                return false;
            });
        return isChildHovered;
    }

    static areAllChildrenDisabled(cluster) {
        return cluster?.every?.(point => point.child.props.isDisabled);
    }

    static isAnyChildSelectedForEdit(cluster) {
        let isChildSelectedForEdit = false;
        cluster &&
            cluster.some &&
            cluster.some(point => {
                if (point.child.props.isSelectedForEdit) {
                    isChildSelectedForEdit = true;
                    return true;
                }
                return false;
            });
        return isChildSelectedForEdit;
    }

    static isAnyChildBeingEdited(cluster) {
        let isChildBeingEdited = false;
        cluster &&
            cluster.some &&
            cluster.some(point => {
                if (point.child.props.isBeingEdited) {
                    isChildBeingEdited = true;
                    return true;
                }
                return false;
            });
        return isChildBeingEdited;
    }
}
